import { render, staticRenderFns } from "./GeneralLedger.vue?vue&type=template&id=87e60702&scoped=true"
import script from "./GeneralLedger.vue?vue&type=script&lang=js"
export * from "./GeneralLedger.vue?vue&type=script&lang=js"
import style0 from "./GeneralLedger.vue?vue&type=style&index=0&id=87e60702&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e60702",
  null
  
)

export default component.exports